import React from 'react';
import _ from 'lodash';
import { NOTIFICATIONS } from '_constants';
import { fetchNotifications, updateNotificationAsRead, fetchNotificationCount } from '../services/notifications.services';
import { redirectToRoute } from './common.actions';
import { isResponseSuccess } from 'helpers';
import { showServerResponse } from './modals.actions';
import LinkingService from '../services/linking.services';
import { LINKING_SERVICE, USER_RATING, NOTIFICATION_TOAST_CONFIGURATION } from '../constants';
import { toast } from 'react-toastify';
import NotificationToast from '../components/common/modals/NotificationToast';

export const getNotification = () => async (dispatch, getState) => {
  const memberKey = getState().userprofile.memberKey;
  if (memberKey != null) {
    const response = await dispatch(fetchNotifications(memberKey));
    if (isResponseSuccess(response)) {
      dispatch({ type: NOTIFICATIONS.GET_NOTIFICATIONS, value: response.data });
    }
    return response; // TODO: handle catch and do something about it in the whole file.
  }
};

export const markNotificationAsRead = (id = null, contactKey = null, showUserRating = false) => async (dispatch) => {
  const response = await dispatch(updateNotificationAsRead(id));
  if (isResponseSuccess(response) && showUserRating) {
    dispatch(redirectToRoute(`/referraldetails/${contactKey}/${USER_RATING.SHOW_USER_RATING_POPUP}`));
  }
  return response;
};

export const getNotificationCount = () => async (dispatch, getState) => {
  const memberKey = getState().userprofile.memberKey;
  if (memberKey != null) {
    const response = await dispatch(fetchNotificationCount(memberKey));
    if (isResponseSuccess(response)) {
      dispatch({ type: NOTIFICATIONS.GET_NOTIFICATIONS_COUNT, value: response.data.unreadNotificationsCount });
      LinkingService.sendDataToWrapper({ type: LINKING_SERVICE.SET_BADGE_NUMBER, value: response.data.unreadNotificationsCount });
    }
  }
};

export const getReloadFullPage = routeTo => (dispath, getState) => {
  const stateVal = getState();
  const currentLocation = stateVal.router.location.pathname;
  if (currentLocation.split('/')[1] === routeTo.split('/')[1]) {
    window.location.reload();
  }
};

export const redirectOnNotification = (notification, isToaster = false) => async dispatch => {
  if (!notification) { return; }
  const customData = _.get(notification, 'data', null) || notification;
  const messageContent = {};
  if (notification.message && typeof notification.message !== 'string') { // iOS
    messageContent.title = notification.message.title;
    messageContent.subtitle = notification.message.subtitle;
    messageContent.body = notification.message.body;
  } else { // Android
    messageContent.title = notification.title;
    // messageContent.subtitle = notification.message; //TODO: This is duplicated in notification toast.
    messageContent.body = notification.body;
  }

  const actionType = _.get(customData, 'ActionType', null);
  const userInteraction = notification.foreground == 'background' || isToaster;
  const routeTo = '';

  if (!userInteraction) {
    toast(<NotificationToast onClick={() => dispatch(redirectOnNotification(notification, true))}
      {...messageContent}
    />, NOTIFICATION_TOAST_CONFIGURATION);
    return;
  }
  let response = '';
  if (userInteraction) {
    switch (actionType.toString()) {
      case NOTIFICATIONS.ACTION_TYPE.DISPLAY_ONLY:
        dispatch(redirectToRoute('/dashboard'));
        break;
      case NOTIFICATIONS.ACTION_TYPE.CONFIRM_APPOINTMENT: case NOTIFICATIONS.ACTION_TYPE.MADE_CONTACT:
        dispatch(redirectToRoute(`/referraldetails/${customData.ContactKey}/appointment/${customData.AppointmentId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.AUTOASSIGN_LEADACCEPTANCE:
        dispatch(redirectToRoute(`/autoacceptlead/${customData.ContactKey}/opportunity/${customData.OpportunityId}/appointment/${customData.AppointmentId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.ACCEPT_LEAD:
        dispatch(redirectToRoute(`/leadacceptance/${customData.ContactKey}/opportunity/${customData.OpportunityId}/appointment/${customData.AppointmentId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.APPOINTMENT_OUTCOME:
        dispatch(redirectToRoute(`/appointmentdetails/${customData.AppointmentId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.WEEKLY_STATUS_UPDATE:
        dispatch(redirectToRoute(`/statusupdates/${customData.ContactKey}/${customData.ObjectId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.OPPORTUNITY_CLOSED:
        response = await dispatch(markNotificationAsRead(customData.NotificationId, customData.ContactKey, true));
        dispatch(showServerResponse(response, 'Opportunity Closed', 'Error'));
        break;
      case NOTIFICATIONS.ACTION_TYPE.NEW_TASK:
        await dispatch(markNotificationAsRead(customData.NotificationId));
        dispatch(redirectToRoute(`/taskdetails/${customData.TaskId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.COMPLETE_TASK:
        dispatch(redirectToRoute(`/taskdetails/${customData.TaskId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.APPOINTMENT_REMINDER:
        await dispatch(markNotificationAsRead(customData.NotificationId));
        dispatch(redirectToRoute(`/appointmentdetails/${customData.AppointmentId}`));
        break;
      case NOTIFICATIONS.ACTION_TYPE.DOCUMENT_REJECTED:
        await dispatch(markNotificationAsRead(customData.NotificationId));
        dispatch(redirectToRoute(`/documentrejected/${customData.ContactKey}/opportunity/${customData.ObjectId}`, null, {
          documentName: customData.DocumentName,
          rejectionReason: customData.RejectionReason
        }));
        break;
      default:
        break;
    }

    dispatch(getReloadFullPage(routeTo));
  } else { return false; }
};

export const notificationActions = {
  getNotification,
  markNotificationAsRead,
  getNotificationCount
};
